class CountData {
  constructor(data, id) {
    this.id = id; // this id is used in economyData search and regionData search
    this.totalCount = 0;
    this.data = data.map(i => {
      this.totalCount += i.count;
      return {
        count: i.count,
        date: i.date
      };
    });
  }
}

export default CountData;
